<template>
    <div>
        <p class="mb-0 mt-3">
            <strong>
                {{ shop }}
            </strong>
        </p>
        <loader-btn
            loading-text="Loading..."
            :loading="isLoading"
            variant="primary"
            class="mx-auto my-3"
            @click="goToEtsyLink()"
        >
            Reconnect my store
        </loader-btn>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { getEtsyLogin, setEtsyRequestToken } from '@/api/storesApp/etsy';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';

@Component({
    name: 'EtsyStoreNeedsReconnectionModalItem',
    components: { LoaderBtn }
})
export default class EtsyStoreNeedsReconnectionModalItem extends Vue {
    @Prop({ default: '' }) readonly shop!: string;

    isLoading = false;

    async goToEtsyLink() {
        try {
            this.isLoading = true;
            const { codeVerification, state, url } = await getEtsyLogin();
            setEtsyRequestToken(codeVerification, state, this.shop);
            window.open(url, '_parent');
        } catch (error) {
            console.error('Error during Etsy link redirection:', error);
        } finally {
            this.isLoading = false;
        }
    }
}
</script>
